var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dock"},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"dock-inner"},[_c('router-link',{staticClass:"dock-button",attrs:{"tag":"a","to":item.link,"event":_vm.hideDock ? '' : 'click'}},[_c('i',{class:item.class})])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-addf682a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Dock.vue
// module id = null
// module chunks = 